module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-card-content",
    style: ({
      backgroundImage: 'url(' + _vm.previewSrc + ')'
    })
  }, [_c('div', {
    staticClass: "page-card-gradient -bottom-up"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-card-gradient -top-right-conner"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-card-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-card-container"
  }, [_c('div', {
    staticClass: "preview-text"
  }, [(_vm.title) ? _c('h3', {
    staticClass: "page--title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "mb-15 text-left"
  }, [_vm._v("ข้อความเชิญชวน")]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "captureTextVirtualWrapper",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    ref: "captureTextVirtual",
    staticClass: "page--message captureTextVirtual"
  })]), _vm._v(" "), _c('div', {
    ref: "captureTextDisplay",
    staticClass: "page--message"
  }, [_vm._v("\n        " + _vm._s(_vm.displayMessage) + "\n      ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "page--province"
  }, [(_vm.school) ? _c('span', [_vm._v(_vm._s(_vm.school.name))]) : _vm._e(), _vm._v(" "), (_vm.province) ? _c('span', [_vm._v("จังหวัด" + _vm._s(_vm.province.name))]) : _vm._e()])]), _vm._v(" "), (_vm.owner) ? _c('div', {
    staticClass: "mt-15"
  }, [_c('div', {}, [_vm._v("เจ้าของกองผ้าป่า")]), _vm._v(" "), _c('div', {
    staticClass: "page--owner"
  }, [_vm._v(_vm._s(_vm.owner))])]) : _vm._e()])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-card-image-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/domain-custom/base/logo-domain-desktop.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ebf5e49","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageCardContent.vue
// module id = 1172
// module chunks = 0